/**
 * Checks if the browser navigator is currently online.
 */
export const isNavigatorOnline = (): boolean => {
  if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
    return window.navigator.onLine
  }
  return true
}